const UTILS = require("../libs/utils.js");
var v13498;
module.exports = [{
  name: "Nuke",
  desc: "Calls in a nuclear bomb that detonates after 10 seconds, killing all players that are spawned at the time the nuke goes off",
  slot: 2,
  kills: 25,
  reqAccount: true,
  activate: function (p16718, p16719, p16720) {
    return !p16718.nukeTimer && (p16718.incStat("n", p16719), this.start(p16718, p16719, p16720), p16719.nukes++, true);
  },
  reset: function (p16721) {
    p16721.nukeTimer = 0;
    p16721.nukePlayer = null;
  },
  start: function (p16722, p16723) {
    p16722.nukeTimer = p16722.gameTimer != "skip" && p16722.gameTimer > 0 && !p16722.mode.timed && p16722.gameTimer < 10000 ? p16722.gameTimer - 1 : 10000;
    p16722.nukePlayer = p16723;
    p16722.broadcast("n", 0);
    if (p16722.isCustom) {
      p16722.findTriggers("onNukeStart", p16723);
    }
  },
  update: function (game, p16725, p16726) {
    if (game.endTimer <= 0 && game.nukeTimer && (game.nukeTimer -= p16726, game.nukeTimer <= 0 && (game.nukeTimer = 0, game.broadcast("n", 1), game.nukePlayer))) {
      var vLN02447 = 0;
      for (var vLN02448 = 0; vLN02448 < game.players.list.length; ++vLN02448) {
        v13498 = game.players.list[vLN02448];
        if (!!v13498.active && v13498 != game.nukePlayer && (!v13498.team || game.nukePlayer.team != v13498.team) && !v13498.godMode) {
          vLN02447 += 50;
          game.players.kill(v13498, game.nukePlayer, {
            stk: 0
          }, false, true);
        }
      }
      if (vLN02447) {
        game.nukePlayer.send("6", [40, vLN02447, 0, 1], 0, game.nukePlayer.kills, vLN02447 / 50);
        game.nukePlayer.send("4");
        game.players.score(game.nukePlayer, vLN02447);
      }
      if (game.isCustom) {
        game.findTriggers("onNukeEnd", game.nukePlayer);
      }
      if (game.nukePlayer && game.nukePlayer.account && game.isPubType() && UTILS.randInt(1, 140) == 140) {
        game.giveSkin(game.nukePlayer, "4040", "streak");
      }
    }
  }
}, {
  name: "Airdrop",
  desc: "Calls in a air drop package containing various things.",
  slot: 1,
  kills: 12,
  noCustoms: true,
  activate: function (p16727, p16728) {
    if (p16727.isCustom) {
      return false;
    }
    if (p16728 && p16728.active) {
      var v13499 = p16727.canSee(p16728, p16728.x, p16728.y + 500, p16728.z) == null;
      if (v13499) {
        p16727.incStat("ad", p16728);
        p16727.airDrop.drop(p16728, p16728.x, p16728.y + 500, p16728.z, {});
        return true;
      } else {
        p16728.send("ch", -1, null, "This place is not suitable for an Airdrop", 2);
        return false;
      }
    }
    return false;
  }
}, {
  name: "Refill",
  desc: "Dev Streak",
  slot: 0,
  kills: 5,
  devOnly: true,
  activate: function (p16729, p16730) {
    var now = Date.now();
    return !!p16730 && !p16730.canThrow && !!(now - p16730.lastThrowTime >= 5000) && (p16729.refillPlayer(p16730), true);
  }
}, {
  name: "Bombardment",
  desc: "Deploys a Bomber that carpet bombs the entire map",
  slot: 2,
  kills: 20,
  devOnly: true,
  activate: function (p16731, p16732, p16733) {
    return !p16731.bombardmentTimer && !p16731.bombardmentBombs.length && (this.start(p16731, p16732, p16733), p16732.bombardments++, true);
  },
  calcPos: function (p16734) {
    var vLN02449 = 0;
    var vLN02450 = 0;
    var vLN02451 = 0;
    var vLN02452 = 0;
    var vLN02453 = 0;
    var vLN02454 = 0;
    var vLN02455 = 0;
    var vLN02456 = 0;
    var vLN02457 = 0;
    var vLN611 = 6;
    var vLN612 = 6;
    for (var vLN02458 = 0; vLN02458 < p16734.map.spawns.length; ++vLN02458) {
      v13498 = p16734.map.spawns[vLN02458];
      if (v13498.x < vLN02449) {
        vLN02449 = v13498.x;
      }
      if (v13498.x > vLN02450) {
        vLN02450 = v13498.x;
      }
      if (v13498.z < vLN02451) {
        vLN02451 = v13498.z;
      }
      if (v13498.z > vLN02452) {
        vLN02452 = v13498.z;
      }
      if (v13498.y > vLN02453) {
        vLN02453 = v13498.y;
      }
    }
    vLN02454 = vLN02450 - vLN02449;
    vLN02455 = vLN02452 - vLN02451;
    vLN02456 = vLN02454 / vLN611;
    vLN02457 = vLN02455 / vLN612;
    vLN611 += 4;
    vLN612 += 4;
    vLN02450 += vLN02456 * 2;
    vLN02449 -= vLN02456 * 2;
    vLN02452 += vLN02457 * 2;
    vLN02451 -= vLN02457 * 2;
    var vA761 = [];
    var vVLN02449 = vLN02449;
    for (var vLN02459 = 0; vLN02459 < vLN611; vLN02459++) {
      var vA762 = [];
      var vVLN02451 = vLN02451;
      for (var vLN02460 = 0; vLN02460 < vLN612; vLN02460++) {
        vA762.push(vVLN02449 + UTILS.randFloat(-15, 15), vLN02453 + UTILS.randFloat(250, 500), vVLN02451 + UTILS.randFloat(-15, 15));
        vVLN02451 += vLN02457;
      }
      vVLN02449 += vLN02456;
      vA761.push(vA762);
    }
    p16734.bombardmentBombs = vA761;
  },
  reset: function (p16735) {
    p16735.bombardmentTimer = 0;
    p16735.bombardmentPlayer = null;
    p16735.bombardmentBombs = [];
  },
  end: function (p16736) {
    p16736.bombardmentTimer = 0;
    p16736.bombardmentBombs = [];
  },
  start: function (p16737, p16738, p16739) {
    p16737.bombardmentTimer = 500;
    p16737.bombardmentPlayer = p16738;
    this.calcPos(p16737, p16738, p16739);
    p16737.broadcast("bbm", 0);
  },
  update: function (p16740, p16741, p16742) {
    if (p16740.endTimer <= 0 && p16740.bombardmentTimer && (p16740.bombardmentTimer -= p16742, p16740.bombardmentTimer <= 0)) {
      if (!p16740.bombardmentBombs.length) {
        this.end(p16740);
        p16740.broadcast("bbm", 1);
        return;
      }
      p16740.bombardmentTimer = 500;
      p16740.projectiles.initBombs(p16740.bombardmentBombs[0], p16740.bombardmentPlayer);
      p16740.bombardmentBombs.shift();
    }
  },
  onCollision: function (game, p16744) {
    game.players.giveEffect(p16744, 4);
    game.players.giveEffect(p16744, 5);
  },
  onKill: function (game) {
    var vLN10012 = 100;
    game.bombardmentPlayer.send("6", [50, vLN10012, 0, 1], 0, game.bombardmentPlayer.kills, 1);
    game.players.score(game.bombardmentPlayer, vLN10012);
  }
}, {
  name: "Slimer",
  desc: "Equips the player with a slime gun that spawns slime pads which players gain a boost from",
  slot: 0,
  kills: 7,
  activate: function (game, p16747) {
    return !!p16747 && !!p16747.active && !p16747.hasEquipment() && (game.incStat("sl", p16747), game.players.giveWeapon(p16747, 23), true);
  }
}, {
  name: "Juggernaut",
  desc: "Equips the player with a Juggernaut Suit & Minigun",
  slot: 2,
  kills: 30,
  activate: function (p16748, p16749) {
    return !!p16749 && !!p16749.active && !p16749.hasEquipment() && (p16748.incStat("jg", p16749), p16748.setJuggernaut(p16749, true), true);
  }
}, {
  name: "War Machine",
  desc: "Equips the player with a Powerful Grenade Launcher",
  slot: 1,
  kills: 15,
  activate: function (game, p16751) {
    return !!p16751 && !!p16751.active && !p16751.hasEquipment() && (game.incStat("wm", p16751), game.players.giveWeapon(p16751, 26), true);
  }
}];
for (var vLN02461 = 0; vLN02461 < module.exports.length; ++vLN02461) {
  module.exports[vLN02461].index = vLN02461;
}